import Swiper from 'swiper';
import { A11y, Pagination } from 'swiper/modules';
import 'swiper/css';

// Size every card to the tallest one currently in view, not the tallest in the whole carousel.
function matchVisibleHeights(swiper) {
	const slides = Array.from(swiper.slides);
	const perView = Math.ceil(swiper.params.slidesPerView);

	slides.forEach((slide) => {
		slide.style.height = '';
	});

	const visible = slides.slice(swiper.activeIndex, swiper.activeIndex + perView);
	const height = Math.max(...visible.map((slide) => slide.offsetHeight));

	slides.forEach((slide) => {
		slide.style.height = `${height}px`;
	});
}

document.querySelectorAll('.testimonial-carousel .carousel').forEach((carousel) => {
	new Swiper(carousel.querySelector('.swiper'), {
		modules: [A11y, Pagination],
		a11y: {
			slideRole: null,
		},
		slidesPerView: 1.1,
		slidesPerGroup: 1,
		spaceBetween: 16,
		watchOverflow: true,
		pagination: {
			el: carousel.querySelector('.carousel-pagination'),
			clickable: true,
		},
		breakpoints: {
			768: { slidesPerView: 2, slidesPerGroup: 2, spaceBetween: 24 },
			1024: { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 24 },
		},
		on: {
			init: matchVisibleHeights,
			slideChange: matchVisibleHeights,
			resize: matchVisibleHeights,
		},
	});
});
